export default {
    title: "Verificação de endereço",
    header: "@:views.address.verified.title",
    message: "Obrigado por verificar seu endereço. Agora você pode escolher este como endereço de entrega ao fazer um pedido.",
}